import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ActionSheetSeparatorProps = ComponentProps<'hr'>;

export const ActionSheetSeparator = memo(({ className, ...restOfProps }: ActionSheetSeparatorProps) => {
  return <hr className={cn('-mx-2 h-px border-0 bg-grey-4', className)} {...restOfProps} />;
});

ActionSheetSeparator.displayName = 'ActionSheetSeparator';
